(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('autocomplete', autocomplete);

    /* @ngInject */
    function autocomplete() {
        var directive = {
            bindToController: true,
            templateUrl: "autocomplete.tpl",
            controller: autocompleteCtrl,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                fieldModel: '=ngModel',
                choices: '<'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.vm.expanded = false;
            scope.vm.searchValue = '';
        }
    }
    /* @ngInject */
    function autocompleteCtrl($scope) {
        $scope.change = function(v) {
            if (typeof $scope.vm.fieldModel == 'undefined') {
                $scope.vm.fieldModel = {};
            }
            $scope.vm.fieldModel.value = v;
            $scope.vm.expanded = false;
        };

        $scope.toggle = function() {
            $scope.vm.expanded = !$scope.vm.expanded;
            if ($scope.vm.expanded) {
                setTimeout(function() {
                    angular.element('.autocomplete-dropdown + div input')[0].focus();
                }, 500);
            }
        };

        $scope.listFilter = function(item) {
            return !item.value || !$scope.vm.searchValue || (item.title.toLowerCase().indexOf($scope.vm.searchValue.toLowerCase()) != -1);
        };

        $scope.$watch('vm.fieldModel.value', function(v) {
            if ($scope.vm.choices.length == 0) {
                return;
            }
            if (v)  {
                var i = $scope.vm.choices.find(function(e) {
                    return e.value == v;
                });
                $scope.vm.selected = i.title;
            }
        });

    }
})();